import { combineReducers } from 'redux';
import { put, takeEvery, select } from 'redux-saga/effects';
import prepareBody from '../utils/prepareBody';
import { set, remove } from '../utils/storage';
import {
    GET_ACTIVE_PLAN_SUCCESS,
    FREE_CHARGE_SUCCESS,
    CONFIRM_PLAN_PURCHASE_SUCCESS,
    processOrderFailed,
} from './signup';
import { getTheme } from './theme';
import { FETCH_WORKOUT_SUCCESS } from './workouts';
import { FETCH_YOUR_DATA_SUCCESS } from './analytics';
import { OPEN_FORGOT_PASS_SECTION, openForgotPassSection } from './landing';
import { GET_RACE_SUCCESS, GET_RACE } from './race';

export const CHANGE_FIELD = 'auth/CHANGE_FIELD';
export const LOGIN = 'auth/LOGIN';
export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';
export const LANDING_LOGIN_SUCCESS = 'auth/LANDING_LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'auth/LOGIN_FAILURE';
export const LOGOUT = 'auth/LOGOUT';
export const TOGGLE_FREE_PLAN_CODE_MODAL = 'auth/TOGGLE_FREE_PLAN_CODE_MODAL';
export const FETCH_PLAN_ID = 'auth/FETCH_PLAN_ID';
export const FETCH_PLAN_ID_SUCCESS = 'auth/FETCH_PLAN_ID_SUCCESS';
export const FETCH_PLAN_ID_FAILURE = 'auth/FETCH_PLAN_ID_FAILURE';
export const RESET_LEGACY_RUNNER = 'auth/RESET_LEGACY_RUNNER';
export const SWITCH_PLANID = 'auth/SWITCH_PLANID';
export const SWITCH_PLANID_FAILURE = 'auth/SWITCH_PLANID_FAILURE';

export function planId(state = null, action) {
    switch (action.type) {
        case LANDING_LOGIN_SUCCESS: {
            const sessionKey = action.result.Session_Key;
            set('sessionKey', sessionKey);
            return action.result.plan_id;
        }
        case SWITCH_PLANID:
            return action.planId;
        case GET_RACE_SUCCESS:
            return action.result.plan_id;
        case FETCH_PLAN_ID_SUCCESS:
            return action.result.plan_id ? action.result.plan_id : null;
        case LOGOUT: {
            remove('sessionKey');
            return null;
        }
        default:
            return state;
    }
}

export function runnerId(state = null, action) {
    switch (action.type) {
        case LANDING_LOGIN_SUCCESS: {
            return action.result.runner_id;
        }
        case LOGOUT: {
            return null;
        }
        default:
            return state;
    }
}

export function loading(state = false, action) {
    switch (action.type) {
        case LOGIN:
            return true;
        case LANDING_LOGIN_SUCCESS:
        case LOGIN_SUCCESS:
        case LOGIN_FAILURE:
        case LOGOUT:
            return false;
        default:
            return state;
    }
}

export function error(state = null, action) {
    switch (action.type) {
        case LOGIN:
        case LANDING_LOGIN_SUCCESS:
        case LOGIN_SUCCESS:
        case LOGOUT:
            return null;
        case LOGIN_FAILURE:
            return action.error;
        default:
            return state;
    }
}

export function fields(state = {
    userid: '',
    userkey: '',
}, action) {
    switch (action.type) {
        case LOGOUT:
            return {};
        case CHANGE_FIELD:
            return {
                ...state,
                [action.key]: action.val,
            };
        case LANDING_LOGIN_SUCCESS:
            return {
                ...state,
                userkey: '',
            };
        default:
            return state;
    }
}

export function archived(state = 0, action) {
    switch (action.type) {
        case LANDING_LOGIN_SUCCESS:
            return action.result.Version;
        case FETCH_WORKOUT_SUCCESS:
            return action.result.archived;
        case GET_RACE_SUCCESS:
            return action.result.archived;
        case FETCH_PLAN_ID_SUCCESS:
            return action.result.archived ? action.result.archived : null;
        case LOGOUT:
            return 0;
        case CONFIRM_PLAN_PURCHASE_SUCCESS:
            return 0;
        default:
            return state;
    }
}

export function freePlan(state = { modalOpen: false, modalSeen: false }, action) {
    switch (action.type) {
        case TOGGLE_FREE_PLAN_CODE_MODAL:
            return {
                ...state,
                modalOpen: !state.modalOpen,
                modalSeen: true,
            };
        case FETCH_YOUR_DATA_SUCCESS:
            return {
                ...state,
                available: action.result.COVID[0],
                code: action.result.COVID[1],
                text: action.result.COVID[2],
            };
        default:
            return state;
    }
}

export function done(state = false, action) {
    switch (action.type) {
        case LANDING_LOGIN_SUCCESS:
        case SWITCH_PLANID:
            return true;
        case LOGOUT:
            return false;
        default:
            return state;
    }
}

export function planLoaded(state = false, action) {
    switch (action.type) {
        case SWITCH_PLANID:
        case GET_RACE:
            return false;
        case GET_RACE_SUCCESS:
            return true;
        default:
            return state;
    }
}


export function checkout(state = false, action) {
    switch (action.type) {
        case FETCH_PLAN_ID_SUCCESS:
            return {
                ...state,
                done: true,
                error: action.error,
            };
        case FETCH_PLAN_ID_FAILURE:
            return {
                ...state,
                error: action.error,
            };
        default:
            return state;
    }
}
export function legacyRunner(state = 0, action) {
    switch (action.type) {
        case GET_ACTIVE_PLAN_SUCCESS:
            return action.result.Legacy;
        case OPEN_FORGOT_PASS_SECTION:
            if (action.legacyRunner) {
                return action.legacyRunner;
            }
            return state;
        case RESET_LEGACY_RUNNER:
            return 0;
        default:
            return state;
    }
}

export default combineReducers({
    loading,
    error,
    planId,
    runnerId,
    fields,
    archived,
    freePlan,
    done,
    checkout,
    legacyRunner,
    planLoaded,
});

export const loginAction = (body, failedPurchase) => ({
    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAILURE],
    promise: () => fetch(`${process.env.RTAPI_URL}/API_enterplan.php`, {
        method: 'POST',
        body: prepareBody(body),
    }).then(res => res.json()).then((result) => {
        if (result.Status === 1) {
            throw new Error('Not an active user with that username');
        } else if (result.Status === 2) {
            throw new Error('Incorrect password provided');
        }
        return result;
    }),
    ...body,
    failedPurchase,
});

export function fetchPlanId(body = {}) {
    return {
        types: [FETCH_PLAN_ID, FETCH_PLAN_ID_SUCCESS, FETCH_PLAN_ID_FAILURE],
        promise: () => fetch(`${process.env.RTAPI_URL}/API_getPlanId.php`, {
            method: 'POST',
            body: prepareBody({
                ...body,
            }),
        }).then(res => res.json()),
    };
}

export const logoutAction = newTheme => ({ getState, dispatch }) => dispatch({
    type: LOGOUT,
    state: { theme: { themeId: getState().theme.themeId }, landing: getState().landing },
    themeId: getState().theme.themeId,
    newTheme,
});

export const changeAction = (key, val) => ({
    type: CHANGE_FIELD,
    key,
    val,
});

export const landingLoginSuccess = result => ({
    type: LANDING_LOGIN_SUCCESS,
    result,
});

export const switchPlanId = pId => ({
    type: SWITCH_PLANID,
    planId: pId,
});

export const toggleFreePlanCodeModal = () => ({
    type: TOGGLE_FREE_PLAN_CODE_MODAL,
});

export const resetLegacyRunner = () => ({
    type: RESET_LEGACY_RUNNER,
});

export function* handleLoginSuccess({ result }) {
    if (result.Status === 3) {
        return yield put(openForgotPassSection(1));
    }
    return yield put(landingLoginSuccess(result));
}

export function* handleLoginFailure({ failedPurchase }) {
    if (failedPurchase) {
        return yield put(processOrderFailed());
    }
    return null;
}

export function* watchLogout({ themeId, newTheme }) {
    const theme = newTheme || themeId;
    return yield put(getTheme(theme));
}

export function* watchPurchaseSuccess({ result }) {
    if (result.ecoachUpgrade) {
        return null;
    }

    try {
        const rId = yield select(state => (state.auth.runnerId));
        const pId = yield select(state => (state.signup.planId));
        if (rId) {
            try {
                return yield put(switchPlanId(pId));
            } catch (e) {
                yield put(logoutAction());
            }
        }
    } catch (e) {
        yield put({ type: 'signup/LOGIN_FAILURE', e });
    }

    const signupFields = yield select(state => ({
        userid: state.signup.fields.email,
        userkey: state.signup.fields.password,
    }));
    const planOver = yield select(state => (state.signup.fields.planOver));
    return yield put(loginAction(signupFields, '/signup', planOver));
}

export function* watchFreeChargeSuccess({ result }) {
    if (result.dbSuccess) {
        const signupFields = yield select(state => ({
            userid: state.signup.fields.email,
            userkey: state.signup.fields.password,
        }));
        const planOver = yield select(state => (state.signup.fields.planOver));
        return yield put(loginAction(signupFields, '/signup', planOver));
    }
    return null;
    // error handle
}

export function* watchFetchData() {
    const hasFreePlan = yield select(state => state.auth.freePlan.available);
    const isArchived = yield select(state => state.auth.archived);
    const hasSeenModal = yield select(state => state.auth.freePlan.modalSeen);
    if (hasFreePlan && isArchived && !hasSeenModal) {
        yield put(toggleFreePlanCodeModal());
    }
    return null;
}

export function* rootSaga() {
    yield takeEvery(LOGIN_SUCCESS, handleLoginSuccess);
    yield takeEvery(LOGOUT, watchLogout);
    yield takeEvery(CONFIRM_PLAN_PURCHASE_SUCCESS, watchPurchaseSuccess);
    yield takeEvery(FETCH_YOUR_DATA_SUCCESS, watchFetchData);
    yield takeEvery(FREE_CHARGE_SUCCESS, watchFreeChargeSuccess);
    yield takeEvery(LOGIN_FAILURE, handleLoginFailure);
}

export const selectPlanId = state => state.auth.planId;
export const selectRunnerId = state => state.auth.runnerId;
export const selectArchived = state => state.auth.archived;



/** WEBPACK FOOTER **
 ** ./src/redux/auth.js
 **/